import { ShippingCaseResponse } from "@pages/shippingView/types";
import { api } from "../../../../api";
import {
  CreateInsuranceFields,
  InsuranceResponse,
  ShippingCaseInsurancesRespose,
} from "./types";

export async function getInsurnceApi(
  id: number,
): Promise<ShippingCaseInsurancesRespose> {
  const { data } = await api.get<ShippingCaseInsurancesRespose>(
    `/api/shipping-cases/${id}/insurances`,
  );
  return data;
}

export async function createInsuranceApi({
  params,
  id,
}: {
  params: CreateInsuranceFields;
  id: number;
}): Promise<InsuranceResponse> {
  const { data } = await api.post<InsuranceResponse>(
    `/api/shipping-cases/${id}/insurances`,
    {
      ...params,
    },
  );
  return data;
}

export async function updateInsuranceApi(
  params: CreateInsuranceFields,
  id: number,
  insurance_id: number,
): Promise<ShippingCaseResponse> {
  const { data } = await api.patch<ShippingCaseResponse>(
    `/api/shipping-cases/${id}/insurances/${insurance_id}`,
    {
      ...params,
    },
  );
  return data;
}

export async function removeInsuranceApi(
  id: number,
  insurance_id: number,
): Promise<void> {
  await api.delete<ShippingCaseResponse>(
    `/api/shipping-cases/${id}/insurances/${insurance_id}`,
  );
}
